/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Student_2_AchievementInputs */

const en_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional · Iowa PGA Match Play Champion`)
};

const es_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA · Campeón de match play de la Iowa PGA`)
};

const de_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional · Lochspielmeister der Iowa PGA`)
};

const zh_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA 职业人士 · Iowa PGA 比洞赛冠军`)
};

const ar_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محترف PGA · بطل Iowa PGA Match Play`)
};

const fr_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionnel PGA · Champion de match-play de la Iowa PGA`)
};

const vi_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên gia PGA · Vô địch đấu lỗ Iowa PGA`)
};

const sw_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtaalamu wa PGA · Bingwa wa Iowa PGA Match Play`)
};

const th_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักกอล์ฟอาชีพ PGA · แชมป์แมตช์เพลย์ของ Iowa PGA`)
};

const bs_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA profesionalac · Šampion Iowa PGA Match Play`)
};

const ja_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGAプロ · Iowa PGA マッチプレー優勝`)
};

const ko_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA 프로 · Iowa PGA 매치플레이 챔피언`)
};

const pt_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profissional PGA · Campeão de match play da Iowa PGA`)
};

const it_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionista PGA · Campione di match play della Iowa PGA`)
};

const sv_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-professional · Matchspelsmästare i Iowa PGA`)
};

const nl_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional · Matchplaykampioen van de Iowa PGA`)
};

const da_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-professionel · Hulspilsmester i Iowa PGA`)
};

const nb_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-profesjonell · Matchspillmester i Iowa PGA`)
};

const fi_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-ammattilainen · Iowa PGA:n reikäpelimestari`)
};

const pl_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesjonalista PGA · Mistrz Iowa PGA w grze na dołki`)
};

const ru_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профессионал PGA · Чемпион Iowa PGA по матчевой игре`)
};

const tr_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Profesyoneli · Iowa PGA Match Play şampiyonu`)
};

const hi_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA प्रोफ़ेशनल · Iowa PGA मैच प्ले चैंपियन`)
};

const id_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA · Juara Iowa PGA Match Play`)
};

const ms_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA · Juara Iowa PGA Match Play`)
};

const cs_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesionál PGA · Šampion Iowa PGA v jamkové hře`)
};

const el_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαγγελματίας PGA · Πρωταθλητής match play της Iowa PGA`)
};

const he_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מקצוען PGA · אלוף Iowa PGA Match Play`)
};

const af_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-professional · Iowa PGA-putjiespelkampioen`)
};

const hu_about_content_student_2_achievement = /** @type {(inputs: About_Content_Student_2_AchievementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-profi · Az Iowa PGA lyukjátékbajnoka`)
};

/**
* | output |
* | --- |
* | "PGA Professional · Iowa PGA Match Play Champion" |
*
* @param {About_Content_Student_2_AchievementInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_student_2_achievement = /** @type {((inputs?: About_Content_Student_2_AchievementInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Student_2_AchievementInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_student_2_achievement(inputs)
	if (locale === "de") return de_about_content_student_2_achievement(inputs)
	if (locale === "zh") return zh_about_content_student_2_achievement(inputs)
	if (locale === "ar") return ar_about_content_student_2_achievement(inputs)
	if (locale === "fr") return fr_about_content_student_2_achievement(inputs)
	if (locale === "vi") return vi_about_content_student_2_achievement(inputs)
	if (locale === "sw") return sw_about_content_student_2_achievement(inputs)
	if (locale === "th") return th_about_content_student_2_achievement(inputs)
	if (locale === "bs") return bs_about_content_student_2_achievement(inputs)
	if (locale === "ja") return ja_about_content_student_2_achievement(inputs)
	if (locale === "ko") return ko_about_content_student_2_achievement(inputs)
	if (locale === "pt") return pt_about_content_student_2_achievement(inputs)
	if (locale === "it") return it_about_content_student_2_achievement(inputs)
	if (locale === "sv") return sv_about_content_student_2_achievement(inputs)
	if (locale === "nl") return nl_about_content_student_2_achievement(inputs)
	if (locale === "da") return da_about_content_student_2_achievement(inputs)
	if (locale === "nb") return nb_about_content_student_2_achievement(inputs)
	if (locale === "fi") return fi_about_content_student_2_achievement(inputs)
	if (locale === "pl") return pl_about_content_student_2_achievement(inputs)
	if (locale === "ru") return ru_about_content_student_2_achievement(inputs)
	if (locale === "tr") return tr_about_content_student_2_achievement(inputs)
	if (locale === "hi") return hi_about_content_student_2_achievement(inputs)
	if (locale === "id") return id_about_content_student_2_achievement(inputs)
	if (locale === "ms") return ms_about_content_student_2_achievement(inputs)
	if (locale === "cs") return cs_about_content_student_2_achievement(inputs)
	if (locale === "el") return el_about_content_student_2_achievement(inputs)
	if (locale === "he") return he_about_content_student_2_achievement(inputs)
	if (locale === "af") return af_about_content_student_2_achievement(inputs)
	if (locale === "hu") return hu_about_content_student_2_achievement(inputs)
	return en_about_content_student_2_achievement(inputs)
});